import { TEXTS } from '../../helpers/content';
import { FeatureBox } from '../ContentStyled';
import {
	BonusDesc,
	BonusIcon,
	BonusTitle,
	BonusWrapper,
	Description
} from './Items';
import FeatureBonus from '../../assets/features/feature_bonus_buy.png';
// import { GameConfigs } from '../../../lib/globals/GameConfigs';

export default function BonusBuy({
	scale,
	buyfeatureprice,
	currency,
	currentBet
}) {
	return (
		<FeatureBox>
			<Description scale={scale}>{TEXTS.features[0].bonus_desc_1}</Description>
			<BonusWrapper scale={scale}>
				<div className='text'>
					<BonusTitle scale={scale}>Buy Bonus</BonusTitle>
					<BonusDesc scale={scale}>
						{currency}
						{(currentBet * buyfeatureprice).toLocaleString(undefined, {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0
						})}
					</BonusDesc>
				</div>
				<BonusIcon scale={scale}>
					<img src={FeatureBonus} alt='feature' />
				</BonusIcon>
			</BonusWrapper>
			<Description scale={scale}>
				{TEXTS.features[0].bonus_desc_2} {parseInt(buyfeatureprice)}X{' '}
				{TEXTS.features[0].bonus_desc_3}
			</Description>
		</FeatureBox>
	);
}
